import { pipe } from 'ramda';
import { setAction, setLabel, setReceivedLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchGetApplicationStatusErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_application_status_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchGetAccountInfoErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_account_information_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchRequestClaimAdditionErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_claim_addition_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchVerifyClaimErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_verify_claim_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchResendCodeErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_resend_code_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchHasPayrollErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_has_payroll_product_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchHasPayrollEvent: DispatchEvent = pipe(
  setLabel('has_payroll_product'),
  setAction('request_has_payroll_product'),
  dispatchFrontendDashboardEvent,
);

const dispatchAtWorkAvailableProductsErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_at_work_products_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchAtWorkAvailableProductsEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_at_work_products'),
  dispatchFrontendDashboardEvent,
);

export {
  dispatchGetApplicationStatusErrorEvent,
  dispatchGetAccountInfoErrorEvent,
  dispatchRequestClaimAdditionErrorEvent,
  dispatchVerifyClaimErrorEvent,
  dispatchResendCodeErrorEvent,
  dispatchHasPayrollErrorEvent,
  dispatchHasPayrollEvent,
  dispatchAtWorkAvailableProductsErrorEvent,
  dispatchAtWorkAvailableProductsEvent,
};
